export default __webpack_public_path__ + "static/media/gallery_09.0b91dd58.jpg";